
export const apiEndpoints = {
    getkeyWords:"Keywords",
    getVideos:"TrainingVideos",
    getVideoDetail:"TrainingVideos",
    getRelatedVideos:"",
    getAllCategory:"Categories",


    postCreateUser:"User",
    getUser:"User",
    getUserKeywords:"User/Keyword",
    deleteUserKeywords:"User/Keyword",
    postBookmark:"User/Bookmark",
    getBookMarkList:"User/Bookmark",
    deleteBookMark:"User/Bookmark",

    postVideoProgress:"User/VideoProgress",
    postBlogDwell:"User/BlogDwell",

    postCompleted:"User/Completed",
    deleteCompleted:"User/Completed",
    getCompletedList:"User/Completed",
    postInprogress:"User/InProgress",
    getInProgressList:"User/InProgress",

    addKeywords:"User/keyword",
    getSavedKeywords:"User/keyword",
    deleteKeywords:"User/keyword",

    updateProfilePic:"User/ProfilePic",

    getBlogsApis:"BlogApi",
    bookmarkblog:"BlogApi/bookmark",
    removebookmarkblog:"BlogApi/unbookmark",
    getbookmarkblog:"BlogApi/bookmarked-blogs",
    relatedBlogs:"BlogApi/blogs-by-category",

    getTimeZone:"User/TimeZone",
    setLanguage:"User/Language",

    notification:"SendNotificationNew",
    blogDetail:"BlogApi/blogs-by-userid",

    getContent:"privacyPolicy",

    welcomeBackApi:"welcomeBackApi"
    
}

export default apiEndpoints;